export const COMPANY = {
  brand: "Les Jardiniers Normands",
  subBrand: "Pro Élagage 14",
  phone: "07 80 04 43 90",
  phoneRaw: "+33780044390",
  email: "schmittantony4@gmail.com",
  address: "13 rue des 4 Vents, 14000 Caen",
  streetAddress: "13 rue des 4 Vents",
  city: "Caen",
  postalCode: "14000",
  region: "Normandie",
  department: "Calvados (14)",
  hours: "Lun-Sam : 8h00 – 19h00",
  whatsapp: "+33780044390",
  logos: {
    jardiniers: "https://customer-assets.emergentagent.com/job_paysage-caen-seo/artifacts/xgkb4d4x_logo%20jardinier%20normand.png",
    proElagage: "https://customer-assets.emergentagent.com/job_paysage-caen-seo/artifacts/pvwtitso_pro%20%C3%A9lagage%2014.jpg",
  },
  social: {
    google: "https://www.google.com/search?q=pro+%C3%A9lagage+14",
    reviewLink: "https://www.google.com/search?q=les+jardiniers+normands+caen#lrd=0x0:0x0,3,,,,",
  },
  site: "https://paysage-caen-seo.emergent.host",
  legal: {
    name: "Schmitt Antony",
    form: "Entreprise individuelle",
    siret: "891 548 802 00026",
    tva: "FR40 891 548 802",
    publisher: "Antony Schmitt",
  },
};
